// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"60":"9dc95b046d737019","3185":"ae6cf259094b4be9","4255":"bf3b217b7955ee0e","8882":"62a0c73b695e26d9","9654":"b5429893e4eb7820"}[chunkId] + ".css";
};